<template>
    <div class="card">
                  <div class="card-header pb-0">
                    <h5>Disabled outline buttons</h5>
                   <span>Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled button</span>
                  </div>
                  <div class="card-body btn-showcase">
                    <button class="btn btn-pill btn-outline-primary disabled" type="button">Disabled</button>
                    <button class="btn btn-pill btn-outline-secondary disabled" type="button">Disabled</button>
                    <button class="btn btn-pill btn-outline-success disabled" type="button">Disabled</button>
                    <button class="btn btn-pill btn-outline-info disabled" type="button">Disabled</button>
                    <button class="btn btn-pill btn-outline-warning disabled" type="button">Disabled</button>
                    <button class="btn btn-pill btn-outline-danger disabled" type="button">Disabled</button>
                    <button class="btn btn-pill btn-outline-light disabled txt-dark" type="button">Disabled</button>
                    
                  </div>
                </div>
                <div class="card">
                  <div class="card-header pb-0">
                    <h5>Gradien buttons</h5>
                    <span>Add <code>.btn-pill</code> and <code>.btn-*-gradien</code>class for gradien button</span>
                  </div>
                  <div class="card-body btn-showcase">
                    <button class="btn btn-pill btn-primary-gradien" type="button">Primary Button</button>
                    <button class="btn btn-pill btn-secondary-gradien" type="button">Secondary Button</button>
                    <button class="btn btn-pill btn-success-gradien" type="button">Success Button</button>
                    <button class="btn btn-pill btn-info-gradien" type="button">Info Button</button>
                    <button class="btn btn-pill btn-warning-gradien" type="button">Warning Button</button>
                    <button class="btn btn-pill btn-danger-gradien" type="button">Danger Button</button>
                    <button class="btn btn-pill btn-light-gradien txt-dark" type="button">Light Button</button>
                    
                  </div>
                </div>
</template>